import { supabase } from '../supabase';

export const fetchOneAutomatedOffers = (automated_task_offer_id: number) => {
  return supabase
    .from('automated_offers')
    .select(
      `
      tasker:taskers (
        name,
        last_name,
        email,
        phone_number,
        assigned_taskers!left (
          task_id
        )
      ),
      automated_task_offer:automated_task_offer (
        task_id
      )
    `
    )
    .eq('automated_task_offer_id', automated_task_offer_id);
};
export const fetchOneByTaskIdAutomatedOffers = (taskId: number) => {
    return supabase
          .from('automated_task_offer')
          .select('id')
          .eq('task_id', taskId)
          .single();
}
export const fetchOneAutomatedOffer = (automatedTaskOfferId: number) => {
    return supabase
    .from('automated_offers')
    .select(
      `
      *,
      tasker:tasker_id (
        id,
        name,
        last_name,
        email,
        phone_number,
        university,
        career,
        carreer,
        university_year
      )
    `
    )
    .eq('automated_task_offer_id', automatedTaskOfferId)
    .eq('status', 'applied');

}

export const fetchAutomatedOfferWithTask =  (automatedTaskOfferId: number) => {
  return supabase
        .from('automated_offers')
        .select(`
          *,
          automated_task_offer!inner(
            id,
            task:tasks!inner(*)
          ),
          tasker:tasker_id (
            id,
            name,
            last_name,
            email,
            phone_number,
            university,
            career,
            carreer,
            university_year,
            photo_selfie_url,
            certificate_regular_alumn_url,
            certificate_criminal_record_url,
            availability
          )
        `)
        .eq('automated_task_offer_id', automatedTaskOfferId)
        .neq('status', 'rejected');

}

export const fetchAutomatedOfferById = (taskId: number) => {
  return supabase
        .from('automated_task_offer')
        .select('id')
        .eq('task_id', taskId)
        .single();
}

export const updateAssignedAutomatedOffer = (automatedTaskOfferId: number, taskerId: number) => {
  return  supabase
  .from('automated_offers')
  .update({ status: 'assigned' })
  .eq('automated_task_offer_id', automatedTaskOfferId)
  .eq('tasker_id', taskerId);

}
export const updateAutomatedOffer = (automatedTaskOfferId: number, taskerId: number) => {
  return supabase
        .from('automated_offers')
        .update({ status: 'pending' })
        .eq('automated_task_offer_id', automatedTaskOfferId)
        .eq('tasker_id', taskerId);

}